import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/performanceCommentCategoryApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues } from '../../types/app/asset.types';
import { PerformanceCommentCategoryInputs } from '../../types/app/peformanceCommentCategory.types';
import { dictionary } from '../../utils/core/dictionary';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/performanceCommentCategory.functions';
import { paths } from '../../utils/core/routes';
import { PerformanceCommentCategoryForm } from './PerformanceCommentCategoryForm';
import { useStyles } from './PerformanceCommentCategoryForm.styles';

export function PerformanceCommentCategoryCreate() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { parentId } = useParams();
  const navigate = useNavigate();
  const { mutate: mutateCreateCommentCategory } = useMutation(api.createItem);

  const handleOnSubmit: SubmitHandler<PerformanceCommentCategoryInputs> = (
    data: PerformanceCommentCategoryInputs,
  ) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      assetId: Number(parentId),
    });
    mutateCreateCommentCategory(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.PERFORMANCE_COMMENT_CATEGORY_EDITED, { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.PERFORMANCE_COMMENT_CATEGORY,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <AssetFullPathHeader
        finalTitle={dictionary.PERFORMANCE_COMMENT_CATEGORY_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <PerformanceCommentCategoryForm
                onSubmit={handleOnSubmit}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.PERFORMANCE_COMMENT_CATEGORY,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
